import { render, staticRenderFns } from "./publish_message.vue.js?vue&type=template&id=c1844a24!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_message.vue?vue&type=template&id=c1844a24"
import script from "./publish_message.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_message.vue?vue&type=script&lang=js"
export * from "./publish_message.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./publish_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports